<template>
    <div>
         <form-header title='Bewerbung' subtitle='' tag=''>
        </form-header>
        <ValidationObserver ref="form">
            <div class="bg-primary">
                <div class="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
                    <transition name="fade">
                        <div
                            class="mt-0 mb-4 bg-red-100 border-2 border-red-200 px-4 py-4 sm:rounded-lg sm:p-4"
                            v-show="formbehaviour.alertrequired"
                        >
                            <div class="md:grid md:grid-cols-1 md:gap-3">
                                <div class="md:col-span-1">
                                    <h3 class="leading-3">
                                        Bitte überprüfen Sie Ihre Eingabe!
                                    </h3>
                                </div>
                            </div>
                        </div>
                    </transition>
                    <transition name="fade">
                        <div
                            class="mt-0 mb-4 bg-red-100 border-2 border-red-200 px-4 py-4 sm:rounded-lg sm:p-4"
                            v-show="formbehaviour.missingFaecher"
                        >
                            <div class="md:grid md:grid-cols-1 md:gap-3">
                                <div class="md:col-span-1">
                                    <h3 class="leading-3">
                                        Sie müssen zumindest ein Fach auswählen!
                                    </h3>
                                </div>
                            </div>
                        </div>
                    </transition>
                    <form-section title="Fragebogen">
                        <drop-down label="Titel Präfix" columns="3" :values="formdata.prefixTitles" v-model="formdata.prefixTitleId"></drop-down>
                        <drop-down label="Titel Suffix" columns="3" :values="formdata.suffixTitles" v-model="formdata.suffixTitleId"></drop-down>
                        <drop-down label="Anrede" columns="3" v-model="bewerbung.geschlecht" :values="[{id:2, name:'Frau'}, {id:1, name:'Herr'}]" rules="required"></drop-down>
                        <text-input label="Vorname" columns="6" v-model="bewerbung.vorname" rules="required"></text-input>
                        <text-input label="Nachname" columns="6" v-model="bewerbung.nachname" rules="required"></text-input>
                        <text-input label="E-Mail" v-model="bewerbung.email" rules="required|email"></text-input>
                        <text-input label="Telefon" v-model="bewerbung.telefon" rules="required"></text-input>
                        <text-input label="Postleitzahl" columns="3" v-model="bewerbung.plz" rules="required|numeric|max:4|min:4"></text-input>
                        <text-input label="Ort" columns="3" v-model="bewerbung.ort" rules="required"></text-input>
                        <div class="col-span-6">
                        <drop-down
                                :values="formdata.faecher"
                                v-model="faecherId"
                                label="Welche Fächer können Sie an einer niederösterreichischen Musikschule unterrichten?"
                                columns="5"
                                class="mb-1"
                            ></drop-down>
                           
                                <span
                                    v-for="(id, index) in bewerbung.faecherIds"
                                    :key="index"
                                    class="inline-flex items-center mr-1 px-3 py-0.5 rounded-full text-sm font-medium leading-5 bg-indigo-100 text-indigo-800"
                                >
                                    {{
                                        formdata.faecher.find(
                                            fach => fach.id == id
                                        ).name
                                    }}
                                    <button
                                        type="button"
                                        @click="removeFach(id)"
                                        class="flex-shrink-0 -mr-0.5 ml-1.5 inline-flex text-indigo-500 focus:outline-none focus:text-indigo-700"
                                        aria-label="Remove large badge"
                                    >
                                        <svg
                                            class="h-2 w-2"
                                            stroke="currentColor"
                                            fill="none"
                                            viewBox="0 0 8 8"
                                        >
                                            <path
                                                stroke-linecap="round"
                                                stroke-width="1.5"
                                                d="M1 1l6 6m0-6L1 7"
                                            />
                                        </svg>
                                    </button>
                                </span>
                            </div>

                            <div class="col-span-6">
                        <drop-down
                                :values="formdata.bezirke"
                                v-model="wunschBezirkeId"
                                label="Ich habe Interesse an einer Unterrichtstätigkeit in folgenden Bezirken in NÖ."
                                columns="5"
                                class="mb-1"
                            ></drop-down>
                           
                                <span
                                    v-for="(id, index) in bewerbung.wunschBezirkeIds"
                                    :key="index"
                                    class="inline-flex items-center mr-1 px-3 py-0.5 rounded-full text-sm font-medium leading-5 bg-indigo-100 text-indigo-800"
                                >
                                    {{
                                        formdata.bezirke.find(
                                            bezirk => bezirk.id == id
                                        ).name
                                    }}
                                    <button
                                        type="button"
                                        @click="removeWunschBezirk(id)"
                                        class="flex-shrink-0 -mr-0.5 ml-1.5 inline-flex text-indigo-500 focus:outline-none focus:text-indigo-700"
                                        aria-label="Remove large badge"
                                    >
                                        <svg
                                            class="h-2 w-2"
                                            stroke="currentColor"
                                            fill="none"
                                            viewBox="0 0 8 8"
                                        >
                                            <path
                                                stroke-linecap="round"
                                                stroke-width="1.5"
                                                d="M1 1l6 6m0-6L1 7"
                                            />
                                        </svg>
                                    </button>
                                </span>
                            </div>

                            <radio-button-list
                                title="Haben Sie Interesse an kurzfristigen Vertretungsstellen in den von Ihnen ausgewählten Bezirken?"
                                rules="required"
                                v-model="bewerbung.interesseAnVertretung"
                                :options="{
                                    'Ja': 1,
                                    'Nein': 0,
                                }"
                            />

                            <radio-button-list
                                title="Haben Sie Interesse an Zusatzstunden, falls Sie bereits einer bestehenden Unterrichtstätigkeit nachgehen?"
                                rules="required"
                                v-model="bewerbung.interesseAnZusatzstunden"
                                :options="{
                                    'Ja': 1,
                                    'Nein': 0,
                                }"
                            />

                            <div class="col-span-6" v-if="bewerbung.interesseAnZusatzstunden == true">
                        <drop-down
                                :values="formdata.bezirke.filter(bez => bez.id != '00000000-0000-0000-0000-000000000001')"
                                v-model="bezirkeId"
                                label="In welchen Bezirken sind sie bereits tätig?"
                                columns="5"
                                class="mb-1"
                            ></drop-down>
                           
                                <span
                                    v-for="(id, index) in bewerbung.bezirkeIds"
                                    :key="index"
                                    class="inline-flex items-center mr-1 px-3 py-0.5 rounded-full text-sm font-medium leading-5 bg-indigo-100 text-indigo-800"
                                >
                                    {{
                                        formdata.bezirke.find(
                                            bezirk => bezirk.id == id
                                        ).name
                                    }}
                                    <button
                                        type="button"
                                        @click="removeBezirk(id)"
                                        class="flex-shrink-0 -mr-0.5 ml-1.5 inline-flex text-indigo-500 focus:outline-none focus:text-indigo-700"
                                        aria-label="Remove large badge"
                                    >
                                        <svg
                                            class="h-2 w-2"
                                            stroke="currentColor"
                                            fill="none"
                                            viewBox="0 0 8 8"
                                        >
                                            <path
                                                stroke-linecap="round"
                                                stroke-width="1.5"
                                                d="M1 1l6 6m0-6L1 7"
                                            />
                                        </svg>
                                    </button>
                                </span>
                            </div>
                            <div class="col-span-6" v-if="bewerbung.interesseAnZusatzstunden == true">
                        <drop-down
                                :values="this.musikschuleZurAuswahl"
                                v-model="musikschuleId"
                                label="In welchen Musikschulen sind sie bereits tätig?"
                                columns="5"
                                class="mb-1"
                                v-if="this.musikschuleZurAuswahl.length > 0"
                            ></drop-down>
                           
                                <span
                                    v-for="(id, index) in bewerbung.musikschuleIds"
                                    :key="index"
                                    class="inline-flex items-center mr-1 px-3 py-0.5 rounded-full text-sm font-medium leading-5 bg-indigo-100 text-indigo-800"
                                >
                                    {{
                                        formdata.musikschulen.find(
                                            ms => ms.id == id
                                        ).name
                                    }}
                                    <button
                                        type="button"
                                        @click="removeMusikschule(id)"
                                        class="flex-shrink-0 -mr-0.5 ml-1.5 inline-flex text-indigo-500 focus:outline-none focus:text-indigo-700"
                                        aria-label="Remove large badge"
                                    >
                                        <svg
                                            class="h-2 w-2"
                                            stroke="currentColor"
                                            fill="none"
                                            viewBox="0 0 8 8"
                                        >
                                            <path
                                                stroke-linecap="round"
                                                stroke-width="1.5"
                                                d="M1 1l6 6m0-6L1 7"
                                            />
                                        </svg>
                                    </button>
                                </span>
                            </div>
                            
                    </form-section>
                    <form-section title="Information zum Datenschutz">
                        <div class="col-span-6">
                        <check-box label="Zustimmung Datenverarbeitung" columns="6" rules="required" v-model="bewerbung.zustimmungDatenVerarbeitung"></check-box>
                        </div>
                        <div class="col-span-6 sm:col-span-5">
                        <text-block :content="textbausteinfuer('bewerbung.datenverarbeitung')"/>
                        </div>
                                                <div class="col-span-6">
                        <check-box label="Zustimmung Datenweitergabe an interessierte Musikschulleiter:innen (optional)" columns="6" v-model="bewerbung.datenVeroeffentlichen"></check-box>
                        </div>
                        <div class="col-span-6 sm:col-span-5">
                        <text-block :content="textbausteinfuer('bewerbung.homepageInformation')"/>
                        </div>
                        <div class="col-span-6">
                        <check-box label="Gelesen: DSGVO Information" columns="6" rules="required" v-model="bewerbung.gelesenDSGVO"></check-box>
                        </div>
                        <div class="col-span-6 sm:col-span-5">
                        <text-block :content="textbausteinfuer('allgemein.informationspflicht')"/>
                        </div>

                    </form-section>
                    <div
                        class="mt-6 bg-white shadow px-4 py-5 sm:rounded-lg sm:p-6"
                        >
                        <div class="sm:grid sm:grid-cols-3 sm:gap-6">
                            <div class="sm:col-span-1">&nbsp;</div>
                            <span
                                class="inline-flex rounded-md shadow-sm"
                            >
                                <button
                                    @click="sendBewerbung()"
                                    type="button"
                                    class="inline-flex items-center px-48 sm:px-8 py-2 border border-transparent text-base leading-6 font-medium rounded-md text-white bg-green-600 hover:bg-green-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-green active:bg-green-700 transition ease-in-out duration-150"
                                >
                                    Bewerbung absenden
                                </button>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </ValidationObserver>
        <transition name="fade">
            <div
                v-show="formbehaviour.successful"
                class="fixed bottom-0 inset-x-0 px-4 pb-6 sm:inset-0 sm:p-0 sm:flex sm:items-center sm:justify-center"
            >
                <div
                    v-show="formbehaviour.successful"
                    class="fixed inset-0 transition-opacity"
                >
                    <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
                </div>

                <div
                    v-show="formbehaviour.successful"
                    class="bg-white rounded-lg px-4 pt-5 pb-4 overflow-hidden shadow-xl transform transition-all sm:max-w-sm sm:w-full sm:p-6"
                >
                    <div>
                        <div
                            class="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100"
                        >
                            <svg
                                class="h-6 w-6 text-green-600"
                                stroke="currentColor"
                                fill="none"
                                viewBox="0 0 24 24"
                            >
                                <path
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-width="2"
                                    d="M5 13l4 4L19 7"
                                />
                            </svg>
                        </div>
                        <div class="mt-3 text-center sm:mt-5">
                            <h3
                                class="text-lg leading-6 font-medium text-gray-900"
                            >
                                Erfolgreich gesendet.
                            </h3>
                            <div class="mt-2">
                                <p class="text-sm leading-5 text-gray-500">
                                    Sie können das Fenster nun schließen.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
        <transition name="fade">
            <div
                class="fixed inset-0 flex items-end justify-center px-4 py-6 pointer-events-none sm:p-6 sm:items-start sm:justify-end"
            >
                <div
                    v-show="formbehaviour.sending"
                    class="max-w-sm w-full bg-white shadow-lg rounded-lg pointer-events-auto"
                >
                    <div class="rounded-lg shadow-xs overflow-hidden">
                        <div class="p-4">
                            <div class="flex items-start">
                                <div class="flex-shrink-0">
                                    <svg
                                        class="h-6 w-6 text-green-400"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        stroke="currentColor"
                                    >
                                        <path
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            stroke-width="2"
                                            d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                                        />
                                    </svg>
                                </div>
                                <div class="ml-3 w-0 flex-1 pt-0.5">
                                    <p
                                        class="text-sm leading-5 font-medium text-gray-900"
                                    >
                                        Validierung erfolgreich.
                                    </p> 
                                    <p
                                        class="mt-1 text-sm leading-5 text-gray-500"
                                    >
                                        Übermittle das Ansuchen.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </div>
    
</template>

<script>

import FormHeader from '@/components/forms/FormHeader.vue';
import FormSection from '@/components/forms/FormSection.vue';
import DropDown from '@/components/inputs/DropDown.vue';
import TextInput from '@/components/inputs/TextInput.vue';
import TextBlock from '@/components/inputs/TextBlock.vue';
import CheckBox from '@/components/inputs/CheckBox.vue';

import RadioButtonList from '@/components/inputs/RadioButtonList.vue'

export default {
    name: 'Form',
    inject: ['service'],
    data: function() {
        return {
            formbehaviour: {
                alertrequired: false,
                sending: false,
                successful: false,
                missingFaecher:false,
            },
            faecherId: null,
            bezirkeId: null,
            musikschuleId: null,
            wunschBezirkeId: null,
            formdata: {          
                faecher: [],
                bezirke: [],
                musikschulen: [],
                musikschulenDerBezirke: [],
                textbausteine: [],
                prefixTitles: [],
                suffixTitles: [],
                prefixTitleId: null,
                suffixTitleId: null,
            },
            bewerbung: {
                prefixTitle: null,
                suffixTitle: null,
                geschlecht: null,
                email: null,
                telefon: null,
                nachname: null,
                vorname: null,
                faecherIds: [],
                bezirkeIds: [],
                wunschBezirkeIds: [],
                musikschuleIds: [],
                plz: null,
                ort: null,
                zustimmungDatenVerarbeitung: null,
                datenVeroeffentlichen: false,
                gelesenDSGVO: null,
                interesseAnVertretung: 0,
                interesseAnZusatzstunden: 0,
            }
        }
    },
    components: {
        FormHeader,
        FormSection,
        DropDown,
        TextInput,
        TextBlock,
        TextInput,
        CheckBox,
        RadioButtonList,
    },
    watch: {
        faecherId: function(newvalue, oldvalue) {
            if (newvalue && this.bewerbung.faecherIds.indexOf(newvalue) < 0) {
                this.bewerbung.faecherIds.push(newvalue)
            }

            this.faecherId = null
        },
        bezirkeId: function(newvalue, oldvalue) {
            if (newvalue && this.bewerbung.bezirkeIds.indexOf(newvalue) < 0) {
                this.bewerbung.bezirkeIds.push(newvalue)
            }

            this.bezirkeId = null
        },
        wunschBezirkeId: function(newvalue, oldvalue) {
            if(newvalue == '00000000-0000-0000-0000-000000000001'){
                this.bewerbung.wunschBezirkeIds = []
            }
            else if(newvalue != null){
                this.removeWunschBezirk('00000000-0000-0000-0000-000000000001')
            }
            
            if (newvalue && this.bewerbung.wunschBezirkeIds.indexOf(newvalue) < 0) {
                this.bewerbung.wunschBezirkeIds.push(newvalue)
            }

            this.wunschBezirkeId = null
        },
        musikschuleId: function(newvalue, oldvalue) {
            if (newvalue && this.bewerbung.musikschuleIds.indexOf(newvalue) < 0) {
                this.bewerbung.musikschuleIds.push(newvalue)
            }

            this.musikschuleId = null
        },
    },
    computed:{
        musikschuleZurAuswahl() {
            return  this.formdata.musikschulen.filter(ms => {
                return this.bewerbung.bezirkeIds.find(bez => bez == ms.bezirkId)
            })
        }
    },
    methods: {
        async fetchFaecher() {
            const {data} = await this.service.bewerbung.faecher();
            this.formdata.faecher = data;
        },
        async fetchMusikschulen() {
            const {data} = await this.service.musikschule.powerAppsAlle();
            this.formdata.musikschulen = data;
        },
        async fetchBezirke() {
            const {data} = await this.service.bewerbung.bezirke();
            this.formdata.bezirke = data;

            this.formdata.bezirke.unshift({
                id: '00000000-0000-0000-0000-000000000001',
                name: 'Alle Bezirke'
            })
        },
        setupTitles() {
            var pTitles = ['DDr.', 'Dipl.-Ing.', 'Dr.', 'Dr. Mag.', 'Mag.', 'Mag. (FH)', 'MMag.'];
            var sTitles = ['B.A.', 'M.A.', 'MBA', 'MSc'];

            pTitles.forEach((title, index) => {
                this.formdata.prefixTitles.push({id: index, name: title});
            })

            sTitles.forEach((title, index) => {
                this.formdata.suffixTitles.push({id: index, name: title});
            })
        },
        textbausteinfuer(id) {
            const found = this.formdata.textbausteine.find(
                element => element.identifier == id
            )

            if (!found) return id

            return found.content
        },
        async fetchTextBausteine() {
            const { data } = await this.service.formular.get('initiativbewerbung').textbloeckePowerApps();
            this.formdata.textbausteine = data;
        },
        removeFach(id) {
            const index = this.bewerbung.faecherIds.indexOf(id)
            if (index > -1) {
                this.bewerbung.faecherIds.splice(index, 1)
            }
        },
        removeBezirk(id) {
            const index = this.bewerbung.bezirkeIds.indexOf(id)
            if (index > -1) {
                this.bewerbung.bezirkeIds.splice(index, 1)
            }
        },
        removeWunschBezirk(id) {
            const index = this.bewerbung.wunschBezirkeIds.indexOf(id)
            if (index > -1) {
                this.bewerbung.wunschBezirkeIds.splice(index, 1)
            }
        },
        removeMusikschule(id) {
            const index = this.bewerbung.musikschuleIds.indexOf(id)
            if (index > -1) {
                this.bewerbung.musikschuleIds.splice(index, 1)
            }
        },
        async sendBewerbung() {
           var validation = await this.$refs.form.validate();

           if(this.bewerbung.wunschBezirkeIds.length == 1 && this.bewerbung.wunschBezirkeIds[0] == '00000000-0000-0000-0000-000000000001'){
             this.bewerbung.wunschBezirkeIds = this.formdata.bezirke.filter(bez => bez.id != '00000000-0000-0000-0000-000000000001').map(el => el.id)
           }

            if (!validation) {
                    window.scrollTo(0, 0);
                    this.formbehaviour.alertrequired = true;
                    return;
            }

            if (this.bewerbung.faecherIds.length == 0)
            {
                window.scrollTo(0, 0);
                this.formbehaviour.missingFaecher = true;
                return;
            }
            try {

                if(this.formdata.prefixTitleId != null) {
                    this.bewerbung.prefixTitle = this.formdata.prefixTitles.find(el =>
                        el.id == this.formdata.prefixTitleId).name
                }
                if(this.formdata.suffixTitleId != null) {
                    this.bewerbung.suffixTitle = this.formdata.suffixTitles.find(el =>
                        el.id == this.formdata.suffixTitleId).name
                }
                this.formbehaviour.sending = true;
                await this.service.bewerbung.senden(this.bewerbung);
                this.formbehaviour.successful = true;
                
            }
            catch(error) {
                console.log(Object.keys(error), error.message);
            }
            finally {
                this.formbehaviour.sending = false;
            }
        }
    },
    created () {
        this.setupTitles();
        this.fetchFaecher();
        this.fetchBezirke();
        this.fetchMusikschulen();
        this.fetchTextBausteine();

    },
    
}
</script>